export const sortByCreatedDateTime = (data, dateKey = "createdDate", timeKey = "createdTime") => {
	if (!Array.isArray(data)) {
		console.warn('sortByCreatedDateTime: Provided data is not an array.', data);
		return []; // or throw an error, depending on how you want to handle it
	}

	return [...data].sort((a, b) => {
		const dateTimeA = new Date(`${a[dateKey]}T${a[timeKey]}`);
		const dateTimeB = new Date(`${b[dateKey]}T${b[timeKey]}`);
		return dateTimeB - dateTimeA; // Sort in descending order (latest first)
	});
};

export const parseRequestDateTime = (dateStr, timeStr) => {
  // "19 November 2024" → "19 November 2024"
  // "01.47 AM" → "01:47 AM"
  const normalizedTime = timeStr.replace(".", ":");

  return new Date(`${dateStr} ${normalizedTime}`);
};